/*
 * Kickflip → properties italiane
 * Intercetta le aggiunte al carrello (/cart/add, /cart/add.js — fetch, XHR e form)
 * e, per le righe create dal configuratore Kickflip, aggiunge dentro _mczr_attributes
 * (la lista che Kickflip trasforma nelle properties della riga d.ordine), accanto
 * alle voci in lingua, le stesse voci con etichetta e valore in italiano (visibili).
 * Le properties originali non vengono mai modificate.
 */
(function () {
  "use strict";

  // ─── DIZIONARIO EN → IT (fonte: "Testi per il Configuratore", 8-9-2026) ───

  var KEYS = {
    "SCEGLI IL FORMATO":             ["CHOOSE THE FORMAT"],
    "SCEGLI IL BLEND":               ["CHOOSE THE BLEND"],
    "SCEGLI L'INCLUSIONE (Max 1)":   ["CHOOSE YOUR INCLUSION (Max 1)"],
    "RENDI UNICO IL TUO REGALO":     ["MAKE YOUR GIFT UNIQUE"],
    "PERSONALIZZA IL TUO MESSAGGIO": ["PERSONALIZE YOUR MESSAGE"]
  };

  var VALUES = {
    // Formato
    "700 g": ["700g"],
    "900 g": ["900g"],
    // Blend
    "Bianco":       ["White"],
    "Latte":        ["Milk"],
    "Gianduia":     ["Gianduja"],
    "Fondente 70%": ["70% Dark Chococlate", "70% Dark Chocolate"], // typo nel testo EN ufficiale
    "Fondente 90%": ["90% Dark Chococlate", "90% Dark Chocolate"],
    "Biancolatte":  [],
    "Porcelana":    [],
    // Inclusione
    "Solo cioccolato - No inclusioni": ["Plain chocolate - no inclusions"],
    "Pistacchio Verde di Bronte DOP":  ["Green Pistachio of Bronte"],
    "Nocciole Piemonte IGP":           ["Piedmont Hazelnuts"],
    "Mandorle d'Avola PAT":            ["Avola Almonds"],
    "Granella di Caffè":               ["Coffee nibs"],
    "Granella di Cacao":               ["Cocoa nibs"],
    "Sale di Volterra":                ["Volterra Salt"],
    "Frutti Rossi":                    ["Red Fruits", "Red Berries"],
    "Frutti Gialli":                   ["Yellow Fruits"],
    // Biglietto
    "Utilizza il biglietto standard incluso nella confezione": ["Use the standard card included in the box"],
    "Personalizza il tuo biglietto":   ["Personalize your card"]
  };

  // Chiavi IT con testo libero del cliente: il valore NON si traduce...
  var FREE_TEXT = ["PERSONALIZZA IL TUO MESSAGGIO"];

  // ...tranne il messaggio automatico, che non è scritto dal cliente
  var DEFAULT_MESSAGE = {
    "Ho scelto per te una creazione Amedei unica, personalizzata nel gusto e nella forma, affinchè questo dono rappresenti qualcosa di autenticamente tuo.": [
      "I have chosen for you a unique Amedei creation, personalized in taste and form, so that this gift truly represents something that is authentically yours."
    ]
  };

  var PREFIX = ""; // le voci italiane hanno la stessa etichetta del sito IT
  var FLAG_MISSING = "_IT da verificare"; // nascosta al cliente: elenca le voci senza traduzione
  var ADD_RE = /\/cart\/add(\.js)?\/?$/;

  // ─── MOTORE ───

  function norm(s) {
    return String(s == null ? "" : s)
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/[’‘`]/g, "'").replace(/[“”]/g, '"')
      .replace(/[–—]/g, "-")
      .replace(/\s+/g, " ").trim().toLowerCase();
  }

  function buildMap(dict) {
    var m = {};
    Object.keys(dict).forEach(function (it) {
      m[norm(it)] = it;
      dict[it].forEach(function (a) { m[norm(a)] = it; });
    });
    return m;
  }

  var keyMap = buildMap(KEYS);
  var valMap = buildMap(VALUES);
  var defaultMsgMap = buildMap(DEFAULT_MESSAGE);

  function isKickflip(props) {
    return Object.keys(props).some(function (k) { return k.indexOf("_mczr") === 0; });
  }

  // Restituisce SOLO le properties da aggiungere (mai modifica le esistenti)
  function translatedExtras(props) {
    var extra = {};
    if (!props || typeof props !== "object" || !isKickflip(props)) return extra;
    var missing = [];

    Object.keys(props).forEach(function (key) {
      if (key.charAt(0) === "_") return;
      var value = String(props[key]);
      var itKey = keyMap[norm(key)];
      if (!itKey) { missing.push(key); return; }
      if (itKey === key) return; // chiave già in italiano (sito IT): niente da aggiungere

      var itVal;
      if (FREE_TEXT.indexOf(itKey) !== -1) itVal = defaultMsgMap[norm(value)] || value;
      else itVal = valMap[norm(value)];
      if (itVal == null) { missing.push(key + ": " + value); itVal = value; } // valore non in dizionario: resta quello originale

      if (!((PREFIX + itKey) in props)) extra[PREFIX + itKey] = itVal;
    });

    if (missing.length && !(FLAG_MISSING in props)) extra[FLAG_MISSING] = missing.join(" | ");
    return extra;
  }

  // Kickflip impacchetta le properties visibili nella stringa JSON _mczr_attributes
  // ([{key, value}, ...]) e, tra carrello e ordine, sostituisce le properties della
  // riga con quel contenuto: le traduzioni vanno aggiunte DENTRO quell'array.
  var ATTRS_KEY = "_mczr_attributes";

  // Restituisce il nuovo valore di _mczr_attributes (stringa) o null se non cambia
  function augmentAttributes(raw) {
    var list = JSON.parse(raw);
    if (!Array.isArray(list)) return null;
    var asProps = {};
    list.forEach(function (a) { if (a && a.key != null) asProps[a.key] = a.value; });
    var extra = translatedExtras(asProps);
    var keys = Object.keys(extra);
    if (!keys.length) return null;
    keys.forEach(function (k) { list.push({ key: k, value: extra[k] }); });
    return JSON.stringify(list);
  }

  // Aggiorna un oggetto properties "piatto" (in place)
  function augmentProps(props) {
    if (!props || typeof props !== "object") return;
    if (typeof props[ATTRS_KEY] === "string") {
      var updated = augmentAttributes(props[ATTRS_KEY]);
      if (updated) props[ATTRS_KEY] = updated;
    } else {
      Object.assign(props, translatedExtras(props)); // fallback: properties dirette
    }
  }

  // Body JSON: {id, quantity, properties} oppure {items: [{..., properties}]}
  function transformJson(obj) {
    var items = Array.isArray(obj.items) ? obj.items : [obj];
    items.forEach(function (it) { if (it) augmentProps(it.properties); });
    return obj;
  }

  // Body form-encoded / FormData: properties[KEY] oppure items[0][properties][KEY]
  var PROP_FIELD = /^(.*?properties\]?)\[([^\]]+)\]$/;

  // Raggruppa i campi properties[...] per prefisso e calcola cosa cambiare:
  // onChange(nomeCampo, valore, esisteGià)
  function diffParams(entries, onChange) {
    var groups = {};
    entries.forEach(function (e) {
      var m = e[0].match(PROP_FIELD);
      if (m && typeof e[1] === "string") (groups[m[1]] = groups[m[1]] || {})[m[2]] = e[1];
    });
    Object.keys(groups).forEach(function (prefix) {
      var before = groups[prefix];
      var after = Object.assign({}, before);
      augmentProps(after);
      Object.keys(after).forEach(function (k) {
        if (after[k] !== before[k]) onChange(prefix + "[" + k + "]", after[k], k in before);
      });
    });
  }

  function transformParams(p) {
    diffParams(Array.from(p.entries()), function (name, value, exists) {
      if (exists) p.set(name, value); else p.append(name, value);
    });
    return p;
  }

  function transformBody(body) {
    if (typeof body === "string") {
      try { return JSON.stringify(transformJson(JSON.parse(body))); }
      catch (e) { return transformParams(new URLSearchParams(body)).toString(); }
    }
    if (typeof FormData !== "undefined" && body instanceof FormData) return transformParams(body);
    if (body instanceof URLSearchParams) return transformParams(body);
    return body;
  }

  function isAddUrl(url) {
    try { return ADD_RE.test(new URL(url, location.href).pathname); } catch (e) { return false; }
  }

  function safe(fn, fallback) {
    try { return fn(); } catch (e) { console.warn("[kickflip-it]", e); return fallback; }
  }

  // ─── HOOK: fetch ───
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && (input.href || input.url));
      if (init && init.body && isAddUrl(url)) {
        init = Object.assign({}, init, { body: safe(function () { return transformBody(init.body); }, init.body) });
      }
      return origFetch.call(this, input, init);
    };
  }

  // ─── HOOK: XMLHttpRequest (jQuery, vecchie librerie) ───
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__kfItAdd = isAddUrl(url);
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__kfItAdd && body) body = safe(function () { return transformBody(body); }, body);
    return origSend.call(this, body);
  };

  // ─── HOOK: form classico <form action="/cart/add"> ───
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !isAddUrl(form.getAttribute("action") || "")) return;
    safe(function () {
      diffParams(Array.from(new FormData(form).entries()), function (name, value, exists) {
        var input = exists ? form.querySelector('[name="' + CSS.escape(name) + '"]') : null;
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = name;
          form.appendChild(input);
        }
        input.value = value;
      });
    });
  }, true);

  // Esposto per test da console: KickflipIT.translate({...properties})
  window.KickflipIT = { translate: translatedExtras, augmentAttributes: augmentAttributes };
})();
